<template>
    <b-form @submit="onSubmit" :class="'h-100 d-flex'">
        <b-form-row class="w-100 mx-0">
            <b-col cols="12" sm="4" class="px-0">
                <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
                    <div class="modal-form-legend">
                        <legend v-translate>Details</legend>
                    </div>

                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                                <template slot="label">
                                    {{ $gettext('Cost date') }} <span v-if="showAIfieldsDate" class='ai-icon'>Ai</span>
                                </template>
                                <b-form-datepicker id="input-1" class="inline-form-datepicker" v-model="cost.date" no-flip initial-date="2021-01-01"
                                                    :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"></b-form-datepicker>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label"
                                            :label="$gettext('Cost number*')" label-for="input-2">
                                <b-form-input data-analytics-click id="input-2" v-model="cost.number" required
                                                :placeholder="$gettext('2020-000001')" @input="costNumberChange"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-group v-if="showField('number_on_document')" id="input-group-3" label-class="gk-label-margin gk-modal-label"
                                    :label="$gettext('Number on document')" label-for="input-3">
                        <b-form-input data-analytics-click id="input-3" v-model="cost.number_on_document"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                        <template slot="label">
                            {{ $gettext('Supplier') }} <span v-if="showAIfieldsSupplier" class='ai-icon'>Ai</span>
                        </template>
                        <b-form-group>
                            <CustomerSelector v-model="cost.supplier" :filters="{is_supplier:'True', owner_company:cost.owner_company, is_archived:'False'}"></CustomerSelector>
                        </b-form-group>
                    </b-form-group>

                    <div class="modal-form-legend">
                        <legend v-translate>Amounts</legend>
                    </div>

                    <b-form-group v-if="showField('amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                        <template slot="label">
                            {{ $gettext('Total (inc. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-5" type="number" v-model="cost.amount" placeholder="0.0" step="0.01"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="showField('subtotal_amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                        <template slot="label">
                            {{ $gettext('Total (ex. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-5" type="number" v-model="cost.subtotal_amount" placeholder="0.0" step="0.01"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <b-form-row>
                        <b-col v-for="a_cost_line, index in cost.cost_lines" :key="'taxrate-' + index" cols="12"
                            :lg="(cost.cost_lines.length % 2 != 0 && (index == (cost.cost_lines.length - 1))) ? 12 : 6">
                            <b-form-group id="input-group-7" class="vat-input-size" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                                <template slot="label">
                                    {{ $gettext('VAT') + ' ' + a_cost_line.tax_rate + '%' }} <span v-if="showAIfieldsVAT" class='ai-icon'>Ai</span>
                                </template>
                                <b-input-group>
                                    <template #append>
                                        <b-input-group-text class="btn" @click="calculate(a_cost_line)" :disabled="disableTaxFields()">
                                            <b-icon icon="calculator" />
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input id="input-7" type="number" v-model="a_cost_line.amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col cols="12" lg="6">
                            
                            <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label"
                                    :label="$gettext('Retention')" label-for="input-6">

                                <b-input-group append="%">
                                    <b-form-input data-analytics-click id="input-6" type="number" v-model="cost.retention_tax_percentage"
                                                    :placeholder="$gettext('15.0%')" step="0.01" :disabled="disableTaxFields()">
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group v-if="showField('retention')" id="input-group-6"
                                    label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount')" label-for="input-6">
                                <b-input-group>
                                    <template #append>
                                        <b-input-group-text class="btn" @click="calculateRetentionAmount" :disabled="disableTaxFields()">
                                            <b-icon icon="calculator" />
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input id="input-6" type="number" v-model="cost.retention_tax_amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label">
                                <b-form-checkbox id="input-8" class="checkbox-bg-color" v-model="cost.tax_exempt" :disabled="cost.btw_reversed_charge" switch>
                                    <span class="font-80" v-translate>Exempt from tax</span>&nbsp;
                                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax will be paid on this cost item.')">
                                        <font-awesome-icon icon="fa-regular fa-circle-question" class="font-80 tooltip-icon tooltip-icon--question" />
                                    </span>
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label">
                                <b-form-checkbox id="input-9" class="checkbox-bg-color" v-model="cost.btw_reversed_charge" :disabled="cost.tax_exempt" switch>
                                    <span class="font-80" v-translate>Reversed charge</span>&nbsp;
                                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax has been paid yet on this item. The buyer is responsible to account and report unpaid VAT/sales tax.')">
                                        <font-awesome-icon icon="fa-regular fa-circle-question" class="font-80 tooltip-icon tooltip-icon--question" />
                                    </span>
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="modal-form-legend">
                        <legend v-translate>Categories</legend>
                    </div>
                    <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-4">
                        <b-form-input data-analytics-click id="input-4" v-model="cost.description"
                                        :placeholder="$gettext('Lunch, new laptop, business cards')">
                        </b-form-input>
                    </b-form-group>
                    <b-form-row>
                        <b-col v-if="!transactionCost" cols="12" lg="6">
                            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label"
                                            :label="$gettext('Payment type')" label-for="input-10">
                                <PaymentTypeSelector v-model="cost.payment_type"></PaymentTypeSelector>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" :lg="(!transactionCost) ? 6 : 12">
                            <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label"
                                            :label="$gettext('Cost type*')" label-for="input-6">
                                <CostTypeSelector v-model="cost.cost_type" @change="onCostTypeChange"></CostTypeSelector>
                                <template #description>
                                    <GekkoButton 
                                        @click="redirectCostTypes" 
                                        :text="$gettext('Add cost categories')" 
                                        icon="fa-solid fa-plus" 
                                        class="text-info p-0 w-100 whitesp-normal"
                                        size="sm"
                                        variant="link"
                                    />
                                </template>
                            </b-form-group>

                        </b-col>
                    </b-form-row>
                    <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Customer')" label-for="input-10">
                        <b-form-group>
                            <CustomerSelector v-model="cost.customer" @change="customerCallback"
                                                :filters="{is_customer:'True', owner_company:cost.owner_company, is_archived:'False'}">
                            </CustomerSelector>
                        </b-form-group>
                    </b-form-group>
                    <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Project')" label-for="input-10">
                        <b-form-select v-model="cost.project" :disabled="projectList.length===0">
                            <b-form-select-option v-for="project in projectList" :value="project.id" :key="project.id">
                                {{project.name}}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <CostTransactions :costId="cost.id"></CostTransactions>
                </overlay-scrollbars>
            </b-col>
            <b-col cols="12" sm="8" class="modal-dropzone-actions pr-0">
                <div class="modal-dropzone-actions--wrap">
                    <div class="modal-main-actions">
                        <SmartScanSwitch @change="onSmartScanChange" />
                        <div v-if="scanning || emptyScan" class="w-100">
                            <ProgressBar v-if="scanning" class="w-50 ml-3" />
                            <div class="hint" v-if="emptyScan">We could not find any data. Try again or upload a different file.</div>
                        </div>
                    </div>
                    <div class="modal-dropzone-wrapper">
                        <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged"></VueDropzone>
                    </div>
                </div>
                <b-row class="cost-modal-actions">
                    <b-col cols="12" sm="12" class="cost-complete-info-wrapper">
                        <div class="cost-complete-info h-100" :class="costStatus">
                            <b-row v-show="cost.payment_type=='notpaid'" class="h-100" align-v="center">
                                <b-col cols="10" style="font-size: 13px;">
                                    <b-container>
                                        <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
                                        <span v-translate>This receipt is market as not yet paid.</span>
                                    </b-container>
                                </b-col>
                            </b-row>

                            <b-row v-show="!showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
                                <b-col cols="8" class="cost-info__msg">
                                    <b-container class="cost-info__msg__container">
                                        <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
                                        <div>
                                            <span v-translate>Incomplete. The following fields are missing:</span>
                                            <span v-for="field in isCostComplete()" :key="field">{{field}}</span>
                                        </div>
                                        
                                    </b-container>
                                </b-col>
                                <b-col cols="4" class="cost-info__btn">
                                    <b-container>
                                        <GekkoButton 
                                            @click="toggleComplete" 
                                            :text="$gettext('Ignore')" 
                                            class="text-danger p-0"
                                            variant="link" 
                                        />
                                    </b-container>
                                </b-col>
                            </b-row>

                            <b-row v-show="showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
                                <b-col cols="8" class="cost-info__msg">
                                    <b-container class="cost-info__msg__container">
                                        <font-awesome-icon aria-hidden="true" icon="fa-regular fa-circle-check" />
                                        <span v-translate>Complete</span>
                                    </b-container>
                                </b-col>
                                <b-col cols="4" class="cost-info__btn">
                                    <b-container>
                                        <GekkoButton 
                                            v-if="!allFieldsFilled" 
                                            @click="toggleComplete" 
                                            :text="$gettext('Undo')" 
                                            class="text-danger p-0"
                                            variant="link" 
                                        />
                                    </b-container>
                                </b-col>
                            </b-row>

                        </div>
                    </b-col>
                </b-row>
                <b-row class="bottom-actions">
                    <b-col class="bottom-actions-btn-wrap">
                        <div v-if="$route.name === 'EditCost' && (prevNext.prev || prevNext.next)" class="nav-btns px-2 mr-2">
                            <div :class="{ 'nav-disabled': !prevNext.prev }" id="tooltip-status-prev">
                                <GekkoButton 
                                    v-if="!unsavedChanges" 
                                    @click="navigateTo(prevNext.prev, false)" 
                                    icon="fa-solid fa-arrow-left"
                                    :text="$gettext('Previous')"
                                    variant="link" 
                                />
                                <GekkoButton 
                                    v-else 
                                    @click="navigateTo(prevNext.prev, true)" 
                                    icon="fa-solid fa-arrow-left"
                                    :text="$gettext('Save and Previous')"
                                    variant="link" 
                                />
                                <b-tooltip :disabled="(prevNext.prev) ? true : false" custom-class="nav-tooltip" target="tooltip-status-prev">{{ $gettext('No more results loaded. Please update filters to get more results.') }}</b-tooltip>
                            </div>
                            <div class="nav-separator">|</div>
                            <div :class="{ 'nav-disabled': !prevNext.next }" id="tooltip-status-next">
                                <GekkoButton 
                                    v-if="!unsavedChanges" 
                                    @click="navigateTo(prevNext.next, false)" 
                                    icon="fa-solid fa-arrow-right"
                                    :icon-right="true"
                                    :text="$gettext('Next')"
                                    variant="link" 
                                />
                                <GekkoButton 
                                    v-else
                                    @click="navigateTo(prevNext.next, true)" 
                                    icon="fa-solid fa-arrow-right"
                                    :icon-right="true"
                                    :text="$gettext('Save and Next')"
                                    variant="link" 
                                />
                                <b-tooltip :disabled="(prevNext.next) ? true : false" custom-class="nav-tooltip" target="tooltip-status-next">{{ $gettext('No more results loaded. Please update filters to get more results.') }}</b-tooltip>
                            </div>
                        </div>
                        <GekkoButton 
                            :text="$gettext('Save Cost')"
                            icon="fa-regular fa-floppy-disk"
                            type="submit"
                            :disabled="isSaving"
                            class="float-right"
                        />
                    </b-col>
                </b-row>
            </b-col>
        </b-form-row>
    </b-form>
</template>
<script>
    import VueDropzone from "@/components/VueDropzone";
    import PaymentTypeSelector from "@/components/costs/PaymentTypeSelector";
    import CostTypeSelector from "@/components/costs/CostTypeSelector";
    import CustomerSelector from "@/components/CustomerSelector";
    import SmartScanSwitch from "@/components/SmartScanSwitch";
    import CostTransactions from "@/components/costs/CostTransactions";
    import ProgressBar from "@/components/ui/ProgressBar";
    import GekkoButton from "@/components/GekkoButton";

    import TaxRateService from "@/store/services/taxrate.service.js";
    import CompanyService from "@/store/services/company.service.js";
    import CostService from "@/store/services/cost.service.js";
    import CustomerService from "@/store/services/customer.service.js";
    import ProfileService from "@/store/services/profile.service.js";

    export default {
        name: "EditCost",
        props: {
            prevNext: {
                type: Object,
                default () {
                    return {
                        prev: false,
                        next: false
                    }
                }
            },
            forceCostId: {
                type: Number,
                default: null
            },
            transactionCost: {
                type: Object,
                default: () => {}
            }
        },
        components: {
            GekkoButton, VueDropzone, PaymentTypeSelector, CustomerSelector, CostTypeSelector, SmartScanSwitch,
            CostTransactions, ProgressBar
        },
        data() {
            return {
                isTestingMode: false,
                isSaving: false,
                showAIfieldsDate: false,
                showAIfieldsSupplier: false,
                showAIfieldsVAT: false,
                showAIfieldsAmount: false,
                imageSrc: null,
                tax_rates: [],
                projectList: [],
                scanning: false,
                readyToEdit: false,
                unsavedChanges: false,
                emptyScan: false,
                costtypeObject:{},
                firstCosttypeLoad: true,
                cost: {
                    amount: '',
                    btw_reversed_charge: false,
                    cost_lines: [],
                    cost_type: null,
                    created_by: window.user_id,
                    customer: null,
                    date: new Date().format('Y-m-d'),
                    description: "",
                    id: null,
                    image: null,
                    number: "",
                    number_on_document: "",
                    owner_company: window.company_id,
                    payment_type: "bank",
                    project: null,
                    retention_tax_amount: 0,
                    retention_tax_percentage: 0,
                    subtotal_amount: '',
                    supplier: null,
                    tax_exempt: false,
                    total_tax: 0,
                    marked_as_completed: false,
                },
            }
        },
        watch: {
            cost: {
                handler(){
                    if (this.readyToEdit) {
                        this.unsavedChanges = true
                    }
                },
                deep: true
            }
        },
        async created(){
            ProfileService.getCurrent().then( (response) => {
                this.smartScan = response.data.smart_scan;
            });
            if (this.$route.name === "EditCost" || this.$route.name === "BalanceSheetEditCost" || this.forceCostId) {    //EDIT
                await this.retrieveCost()
                await this.handleCostLines();
                if (this.cost.customer) {
                    await this.customerCallback(this.cost.customer);
                }
            } else {  // CREATE
                this.firstCosttypeLoad = false;
                await this.getCostNumber()
                await this.handleCostLines()
                if (this.transactionCost) {
                    this.cost.amount = parseFloat(Math.abs(this.transactionCost.amount))
                    this.cost.date = this.transactionCost.date
                    this.cost.description = this.transactionCost.description
                }
            }
            this.showForm = true
            this.readyToEdit = true
        },
        methods: {
            async navigateTo (target_id, save) {
                if (target_id) {
                    if (save) await this.saveAndNavigate(target_id)
                    if(!save || this.isSaving) this.$router.push({ name: 'EditCost', params: { costId: target_id } }); 
                }
            },
            async retrieveCost () {
                const cost_id = (this.forceCostId) ? this.forceCostId : this.$route.params['costId']
                return CostService.retrieve(cost_id).then( (response) => {
                    this.cost = response.data;
                    this.$store.commit('costStore/setCostNumber', this.cost.number);
                    this.$store.commit('costStore/setCostToEdit', this.cost);
                    if (this.cost.image) {
                        this.imageSrc = this.cost.image;
                    } else {
                        this.imageSrc = null;
                    }
                })
            },
            onSubmit(e) {
                this.isSaving = true;
                e.preventDefault();
                this.saveCost()
            },
            async saveAndNavigate () {
                this.isSaving = true;
                for (var propName in this.cost) {
                    if (this.cost[propName] === null || this.cost[propName] === undefined) {
                        delete this.cost[propName];
                    }
                }
                if (this.cost.cost_lines.length === 0) {
                    delete this.cost.cost_lines;
                }
                var cost = CostService.prepareCostForUpload(this.cost);
                return CostService.update(cost.id, cost).then( (response) => {
                    this.cost.image = response.data.image;
                    this.$store.commit('setAlert', {title: this.$gettext("Cost Updated"), text:this.$gettext("Successfully edited cost"), variant:"success",duration:4});
                    this.$emit('cost-edit-nav', response.data);
                }).catch( (response) => {
                    this.saveError(response)
                })
            },
            saveCost () {
                for (var propName in this.cost) {
                    if (this.cost[propName] === null || this.cost[propName] === undefined) {
                        delete this.cost[propName];
                    }
                }
                if (this.cost.cost_lines.length === 0) {
                    delete this.cost.cost_lines;
                }
                var cost = CostService.prepareCostForUpload(this.cost);
                if (this.$route.name === "EditCost" || this.$route.name === "BalanceSheetEditCost" || this.forceCostId) {    //EDIT
                    CostService.update(cost.id, cost).then( (response) => {
                        this.cost.image = response.data.image;
                        this.$store.commit('setAlert', {title: this.$gettext("Cost Updated"), text:this.$gettext("Successfully edited cost"), variant:"success",duration:4});
                        this.$emit('edited', response.data);
                    }).catch( (response) => {
                        this.saveError(response)                        
                    })
                } else {
                    CostService.create(cost).then( (response) => {
                        this.$store.commit('setAlert', {title: this.$gettext("Cost Created"), text:this.$gettext("Successfully created cost"), variant:"success",duration:4});
                        this.$emit('created', response.data);
                    }).catch( (response) => {
                        this.saveError(response)                        
                    })
                }
            },
            saveError (response) {
                this.isSaving = false;
                if(response && response.non_field_errors && response.non_field_errors[0] === 'The fields number, owner_company must make a unique set.') {
                    this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Cost not saved, cost number already in use."), variant:"danger",duration:4});
                } else {
                    this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Something went wrong, cost is not saved."), variant:"danger",duration:4});
                }
            },
            toggleComplete(){
                this.cost.marked_as_completed = !this.cost.marked_as_completed;
            },
            async getCostNumber(){
                let vm = this;
                return CompanyService.getNextCostNumber({'year': vm.cost.date.split('-')[0]}).then(function (response) {
                    vm.cost.number = response.data;
                    vm.$store.commit('costStore/setCostNumber', vm.cost.number);
                })
            },
            calculate(cost_line){
                for (let i in this.cost.cost_lines) {
                    this.cost.cost_lines[i].amount = "";
                }
                let vat;
                if (window.company_country === 'ES') {
                    if (this.cost.subtotal_amount) {
                        vat = cost_line.tax_rate / 100 * this.cost.subtotal_amount;
                        vat = vat.toFixed(2);
                    }
                    cost_line.amount = parseFloat(vat);
                } else {
                    if (this.cost.amount) {
                        var vatFactor = cost_line.tax_rate / 100;
                        var base = parseFloat(this.cost.amount) / (1 + vatFactor);
                        vat = (base * vatFactor).toFixed(2);
                    }
                    cost_line.amount = parseFloat(vat);
                }
            },
            calculateRetentionAmount(){
                if (!this.cost.retention_tax_percentage || !this.cost.subtotal_amount) return;
                this.cost.retention_tax_amount = -parseFloat((Math.round(this.cost.retention_tax_percentage * this.cost.subtotal_amount) / 100).toFixed(2));
            },
            onSmartScanChange(){
                this.smartScan = !this.smartScan;
                this.scanning = false;
                if(this.smartScan && this.cost.image){
                    this.doScan(this.cost.image)
                }
            },
            redirectCostTypes(){
                window.location.href = window.Urls['accounts_costtypes_settings']();
            },
            fileChanged(file){
                if(this.smartScan && this.$store.getters['getIsPremium'] && file){
                    this.doScan(file)
                }
                this.cost.image = file;
            },
            doScan (file) {
                this.emptyScan = false
                this.scanning = true
                window.processCostFile(file).then( (googleResponse) => {
                    if(googleResponse && Object.keys(googleResponse.responses[0]).length > 0){
                        this.handleGoogleResponse(googleResponse)
                    } else {
                        this.emptyScan = true
                    }
                    this.scanning = false
                }).catch(() => {
                    this.scanning = false;
                    this.emptyScan = true;
                });
            },
            handleGoogleResponse(googleResponse) {
                var tax1 = 0;
                var tax2 = 0;
                var tax3 = 0;
                if(this.cost.cost_lines.length===1){
                    tax1 = this.cost.cost_lines[0].tax_rate;
                }else if(this.cost.cost_lines.length===2){
                    tax1 = this.cost.cost_lines[0].tax_rate;
                    tax2 = this.cost.cost_lines[1].tax_rate;
                }else if(this.cost.cost_lines.length>2){
                    tax1 = this.cost.cost_lines[0].tax_rate;
                    tax2 = this.cost.cost_lines[1].tax_rate;
                    tax3 = this.cost.cost_lines[2].tax_rate;
                }
                var retention = 0;
                if(this.cost.retention_tax_percentage){
                    retention = this.cost.retention_tax_percentage;
                }
                if(this.isTestingMode){
                    var canvas = document.getElementById('ocr-canvas');
                    canvas.style.display = "block";
                    var ctx = canvas.getContext('2d');
                    ctx.fillStyle = "rgba(255, 0, 0, 0.5)";
                    googleResponse.responses[0].textAnnotations.forEach(function(element, index){
                        if(index>0){
                            var v = element.boundingPoly.vertices;
                            ctx.beginPath();
                            ctx.moveTo(v[0].x, v[0].y);
                            ctx.lineTo(v[1].x, v[1].y);
                            ctx.lineTo(v[2].x, v[2].y);
                            ctx.lineTo(v[3].x, v[3].y);
                            ctx.fill();
                        }
                    });
                }
                let ocrResponse = window.analyzeJSON(googleResponse, window.company_country, tax1, tax2, tax3, retention);
                if (ocrResponse['dateCandidates'].length > 0) {
                    this.showAIfieldsDate = true;
                    this.cost.date = new Date(ocrResponse['dateCandidates'][0].value * 1000).format("Y-m-d");
                }
                if (ocrResponse['taxAmount1Candidates'].length > 0) {
                    this.showAIfieldsVAT = true;
                    this.cost.cost_lines[0].amount = ocrResponse['taxAmount1Candidates'][0].value;
                }
                if (ocrResponse['taxAmount2Candidates'].length > 0) {
                    this.showAIfieldsVAT = true;
                    this.cost.cost_lines[1].amount = ocrResponse['taxAmount2Candidates'][0].value;
                }
                if (ocrResponse['taxAmount3Candidates'].length > 0) {
                    this.showAIfieldsVAT = true;
                    this.cost.cost_lines[2].amount = ocrResponse['taxAmount3Candidates'][0].value;
                }
                if (ocrResponse['totalAmountCandidates'].length > 0) {
                    this.showAIfieldsAmount = true;
                    if (window.company_country === 'ES') {
                        var amount = ocrResponse['totalAmountCandidates'][0].value;
                        var subtotal_amount = amount - this.cost.cost_lines[0].amount - this.cost.cost_lines[1].amount - this.cost.cost_lines[2].amount;
                        this.cost.subtotal_amount = Math.round(subtotal_amount*100)/100;
                    } else {
                        this.cost.amount = ocrResponse['totalAmountCandidates'][0].value;

                        // if (!this.transactionCost) {
                        //     this.cost.amount = ocrResponse['totalAmountCandidates'][0].value;
                        // } else {
                        //     this.cost.amount = this.transactionCost.amount
                        // }
                    }
                }
                if (ocrResponse['supplierCandidates'].length > 0) {
                    let body = {
                        "company_id": window.company_id,
                        "supplierCandidates": ocrResponse['supplierCandidates']
                    }
                    CostService.selectSupplierCandidate(body).then((response) => {
                        if (response.status === 200) {
                            this.cost.supplier = response.data.id;
                            this.showAIfieldsSupplier = true;
                        }
                    });
                }
            },
            showField(fieldname){
                var fields = {};
                fields['ES'] = ['number_on_document', 'subtotal_amount', 'retention'];
                fields['NL'] = ['amount',];
                var country = window.company_country;
                if(!(country in fields)){
                    country = "NL";
                }
                if (fields[country].includes(fieldname)) {
                    return true;
                }
                return false;
            },
            async handleCostLines(){
                let vm = this;
                return TaxRateService.list({country: window.company_country}).then(function (response) {
                    vm.tax_rates = response.data;
                    for (var i = 0; i < vm.filterTaxRates.length; i++) {
                        var a_line = vm.filterTaxRates[i];
                        var cost_line = vm.cost.cost_lines.find(element => element.tax_rate === a_line.taxrate);
                        if (!cost_line) {
                            if(a_line.taxrate>0){
                                vm.cost.cost_lines.push({tax_rate: a_line.taxrate, amount: ''});
                            }
                        }
                    }
                    vm.cost.cost_lines = vm.cost.cost_lines.sort((a, b) => (a.tax_rate > b.tax_rate) ? -1 : ((b.tax_rate > a.tax_rate) ? 1 : 0));
                });
            },
            costNumberChange(value){
                this.$store.commit('costStore/setCostNumber', value);
            },
            async customerCallback(value){
                let vm = this;
                if(!value){
                    this.cost.customer = null;
                    this.cost.project = null;
                    return;
                }
                return CustomerService.retrieve(value, {extended: true}).then(function (response) {
                    vm.projectList = response.data.projects;
                    vm.projectList.unshift({name: vm.$gettext('Nothing Selected'), id: null});
                    for(var i=0; i<vm.projectList.length; i++){
                        if(vm.projectList[i].id === vm.cost.project){
                            return;
                        }
                    }
                    vm.cost.project = null;
                })
            },
            disableTaxFields(){
                var fields_disabled = this.cost.btw_reversed_charge || this.cost.tax_exempt || this.costtypeObject.vat_deductible===false;
                if(fields_disabled){
                    for(var i=0; i<this.cost.cost_lines.length; i++){
                        this.cost.cost_lines[i].amount = '';
                    }
                }
                return fields_disabled;
            },
            isCostComplete(){
                let missingFields = [];
                let taxesPresent = false;
                for (var i in this.cost.cost_lines) {
                    if (this.cost.cost_lines[i].amount < 0 || this.cost.cost_lines[i].amount > 0) {
                        taxesPresent = true;
                        break;
                    }
                }
                if (this.cost.btw_reversed_charge) {
                    taxesPresent = true;
                }
                if (this.cost.tax_exempt) {
                    taxesPresent = true;
                }

                if (!taxesPresent) {
                    missingFields.push(" " + this.$gettext('taxes,'));
                }
                if(window.company_country === "ES"){
                    if (!this.cost.subtotal_amount || this.cost.subtotal_amount == 0) {
                        missingFields.push(" " + this.$gettext('amount,'));
                    }
                    if (!this.cost.supplier) {
                        missingFields.push(" " + this.$gettext('supplier,'));
                    }
                    if (!this.cost.number_on_document) {
                        missingFields.push(" " + this.$gettext('document number,'));
                    }
                }else{
                    if (!this.cost.amount || this.cost.amount <= 0) {
                        missingFields.push(" " + this.$gettext('amount,'));
                    }
                }
                if (!this.cost.image) {
                    missingFields.push(" " + this.$gettext('image,'));
                }
                if (!this.cost.cost_type) {
                    missingFields.push(" " + this.$gettext('cost type,'));
                }
                if(missingFields.length>0){
                    let len = missingFields.length-1;
                    missingFields[len] = missingFields[len].replace(",", ".");
                }
                return missingFields;
            },
            onCostTypeChange(option){
                if(this.firstCosttypeLoad){
                    this.firstCosttypeLoad = false;
                    return;
                }
                // let prevOption = this.costtypeObject;
                this.costtypeObject = option;
                this.disableTaxFields();
                if(this.costtypeObject.vat_deductible){
                    // this.cost.tax_exempt = false;
                    // if (prevOption.vat_deductible === false)
                    //     this.cost.btw_reversed_charge = false;
                }else{
                    this.cost.tax_exempt = true;
                    this.cost.btw_reversed_charge = false;
                }
            },
        },
        computed: {
            filterTaxRates () {
                var out = [];
                for (var i in this.tax_rates) {
                    if (new Date(this.tax_rates[i].start_date) < new Date(this.cost.date) && new Date(this.tax_rates[i].end_date) > new Date(this.cost.date)) {
                        out.push(this.tax_rates[i]);
                    }
                }
                return out;
            },
            showmissingFields () {
                return this.cost.marked_as_completed || this.isCostComplete().length === 0;
            },
            allFieldsFilled () {
                return this.isCostComplete().length === 0;
            },
            costStatus () {
                if(this.cost.payment_type === "notpaid"){
                    return "notpaid";
                }
                if(this.cost.marked_as_completed || this.allFieldsFilled){
                    return "complete"
                }
                return "incomplete"
            }
        }
    };
</script>
<style lang="scss" scoped>
    .vat-input-size {
        min-width: 110px;
    }
    .qestion-icon{
        font-size: 14px;
        color: $colorBlue;
    }
    .push-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .font-80 {
        font-size: 80%;
    }

    .modal-dropzone-actions {
        .modal-dropzone-actions--wrap {
            margin-bottom: 20px; 
            .modal-dropzone-wrapper {
                flex: 1;
                height: calc(100% - 50px) !important; // smartScan height + margin top
                margin-top: 10px;
            }
        }
    }

    .cost-complete-info {
        border: none;
        border-radius: $radiusMd;
        background: lighten($colorUninvoiced, 55%);
        color: $colorUninvoiced;
        padding: 15px 0;
        .svg-inline--fa { margin-right: 5px;}
    }
    .complete{
        border: none;
        color: $colorInvoiced;
        background: lighten($colorInvoiced, 37%);
    }
    .notpaid{
        border: none;
        color: $colorUnpaid;
        background: lighten($colorUnpaid, 37%);
    }
    .ai-icon{
        background: $colorBrand;
        color: white;
        border-radius: 2px;
        padding: 2px;
        font-size: 11px;
    }

    .cost-info {
        align-items: center;
        height: 100%;
        &__msg {
            font-size: 14px;
            line-height: 1;
            .svg-inline--fa { margin-right: 10px; font-size: 16px; }
            &__container {
                display: flex;
                align-items: center;
            }
        }
        &__btn {
            text-align: right;
            font-size: 14px;
        }
    }

    .modal-content {
        height: 100%;
        overflow: hidden;
        .contact-tabs {
            height: 100%;
            .tab-content {
                height: 100%;
                .os-host-overflow-y {
                    padding-right: 1rem;
                }
            }
        }
    }

   .bottom-actions {
       margin-top: 20px;
       .bottom-actions-btn-wrap {
            display: flex;
            width: 100%;
            justify-content: flex-end;
            .nav-btns {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                flex: 1;
                .nav-disabled { opacity: 0.4; }
                .nav-separator { opacity: 0.5; }
            }
       }
   }
    .nav-tooltip { font-size: 12px; line-height: 1.2; }
</style>

<style lang="scss">
.os-theme-dark.os-theme-gekko > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
    background: rgba(0, 0, 0, 0.2);
}
@media (min-width: 575px) {
    .cost-modal {
        .gk-modal-content {
            .modal-content-wrap {
                .os-host:not(.os-host-overflow-y) { 
                    .os-content {
                        padding: 0px 10px 0px 0px !important;
                    }
                }
            }
        }
    }
}
@media (max-width: 575px) {
    .cost-modal {
        .gk-modal-content {
            overflow-y: scroll;
            overflow-x: hidden;
            .modal-content-wrap {
                .os-host { height: auto !important; }
                .modal-dropzone-actions { padding: 0; }
                .cost-modal-actions {
                    .cost-complete-info-wrapper {
                        margin-bottom: 1rem;
                    }
                }
            }
        }
    }
}
</style>